export const colors = {
  logoTextColor: "#031a61",

  // Colours to match generic static pages on Meet
  meetTextColor: "#f1f1f1",
  meetBackground: "#474747",
};
